module.exports = __webpack_public_path__ + "img/live-stream.cae58b88.jpg";